setTimeout(function() {
    const $ = window.jQuery;

    window.renderSelect = async() => {
        let customSelects = $('.hex-select-js select');

        if (customSelects) {
            $('.hex-select-js select').each(function() {
                var $this = $(this);

                $this.addClass('select-hidden');
                $this.wrap('<div class="new-select-custom"></div>');
                $this.after('<div class="select-styled"></div>');

                var $styledSelect = $this.next('div.select-styled');
                $styledSelect.text($this.find('option:selected').text());

                var $list = $('<ul />', {
                    'class': 'select-options',
                    'data-cart-item-key': $this.data('cart-item-key'),
                    'data-product-qty': $this.data('product-qty')
                }).insertAfter($styledSelect);

                $this.children().each(function() {
                    const element = $(this);

                    if (element.is('optgroup')) {
                        $('<li />', {
                            text: element.attr('label'),
                            class: 'group-title'
                        }).appendTo($list);

                        element.children('option').each(function() {
                            const option = $(this);

                            $('<li />', {
                                text: option.text(),
                                rel: option.val(),
                                class: 'list-item'
                            }).appendTo($list);

                            if (option.is(':selected')) {
                                $('li[rel="' + option.val() + '"]').addClass('is-selected')
                            }
                        });
                    } else {
                        $('<li />', {
                            text: element.text(),
                            rel: element.val(),
                            class: 'list-item'
                        }).appendTo($list);

                        if (element.is(':selected')) {
                            $('li[rel="' + element.val() + '"]').addClass('is-selected')
                        }
                    }
                });

                var $listItems = $list.children('li:not(.group-title)');

                $styledSelect.click(function(e) {
                    e.stopPropagation();
                    $('div.select-styled.active').not(this).each(function() {
                        $(this).removeClass('active').next('ul.select-options').hide();
                    });
                    $(this).toggleClass('active').next('ul.select-options').toggle();
                });

                $listItems.click(function(e) {
                    e.stopPropagation();
                    $styledSelect.text($(this).text()).removeClass('active');
                    $this.val($(this).attr('rel'));
                    $list.find('li.is-selected').removeClass('is-selected');
                    $list.find('li[rel="' + $(this).attr('rel') + '"]').addClass('is-selected');

                    var dataKey = $this.data("cart-item-key");
                    var dataSelling = $this.val();
                    var dataQty = $this.data("product-qty");
                    var isSidecart = $this.closest('.skio-sidecart').length > 0;

                    if (isSidecart)
                        updateChangeCart(dataKey, dataSelling, dataQty);

                    $list.hide();
                });

                $(document).click(function() {
                    $styledSelect.removeClass('active');
                    $list.hide();
                });

            });
        }
    }
}, 1000);
